import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { Helps } from 'src/app/libs/helps';
import { ApiService } from 'src/app/services/api.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private api: ApiService, private router: Router, private helps: Helps) { }

  canActivate(): Observable<boolean> {
    // Verificar si existe un token válido en sessionStorage
    const storedToken = sessionStorage.getItem('token');

    if (storedToken) {
      try {
        const decodedToken = this.helps.getToken();
        const level = Number(decodedToken?.level) ?? 0;
        // Si es CENTRALISTA (level 50), no validar contra admin/user/auth/
        if (level === 50) {
          return of(true);
        }
      } catch (e) {
        // Si hay error decodificando, continuar con la validación normal
      }
    }

    // Para ADMIN (99) y SUPERVISOR (2), validar contra admin/user/auth/
    return this.api.isLogged().pipe(
      map((response) => {
        this.helps.saveToken(response);
        return true;
      }),
      catchError((error) => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }

}